import { render, staticRenderFns } from "./upload-pdf.vue?vue&type=template&id=34a53a47&"
import script from "./upload-pdf.vue?vue&type=script&lang=js&"
export * from "./upload-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports